<p-table
  [value]="items"
  [loading]="localLoading()"
>
  <ng-template #header>
    <tr>
      @for (column of columns; track $index) {
        <th
          [class]="column.align + ' text-sm'"
          [ngClass]="{ 'cursor-pointer': column.sortable }"
          (click)="column.sortable && sort(column.slug)"
        >
          {{ column.label }}
          @if (pageControl.orderField === column.slug) {
            @if (pageControl.order === order.ASC) {
              <i class="fa-solid fa-arrow-up"></i>
            }
            @if (pageControl.order === order.DESC) {
              <i class="fa-solid fa-arrow-down"></i>
            }
          }
        </th>
      }
    </tr>
  </ng-template>
  <ng-template #emptymessage>
    <tr>
      <td colspan="8" class="text-center">
        <div class="h-44 p-4 text-zinc-500">
          <ng-lottie [options]="emptyLottieOptions" />
          Nenhum registro encontrado.
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template #body let-item>
    <tr>
      <td>
        {{ item.launch_at | date: 'dd/MM/y' }}<br>
        {{ item.launch_at | date: 'HH:mm:ss' }}
      </td>

      <td>{{ item.id  || '---'}}</td>

      <td>{{ item.account.name || '---' }}</td>

      <td [innerHTML]="item.description || '---'"></td>

      <td
        [ngClass]="{
          'text-rose-600': item.value < 0,
          'text-emerald-600': item.value > 0
        }"
      >
        {{ item.value ? (item.value | currency) : '---' }}
      </td>

      <td
        [ngClass]="{
          'text-rose-600': item.balance < 0,
          'text-emerald-600': item.balance > 0
        }"
      >
        {{ item.balance ? (item.balance | currency) : '---' }}
      </td>

      <!-- <td>
        <div class="flex items-center justify-start gap-1">
          <div
            class="cursor-pointer"
            pTooltip="Exportar"
            tooltipPosition="bottom"
            (click)="export.emit(item.id)"
          >
            <i class="fa-solid fa-file-pdf"></i>
          </div>
          <div
            class="cursor-pointer"
            pTooltip="Editar"
            tooltipPosition="bottom"
            (click)="edit.emit(item)"
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </div>
          <div
            class="cursor-pointer"
            pTooltip="Remover"
            tooltipPosition="bottom"
            (click)="confirmDelete(item.id, $event)"
          >
            <i class="fa-solid fa-ban"></i>
          </div>
          <p-confirmpopup />
        </div>
      </td> -->
    </tr>
  </ng-template>
  <ng-template #footer>
    <tr>
      <td colspan="6">
        <div class="w-full flex justify-end">
          <p-paginator
            (onPageChange)="onPageChange($event)"
            [rows]="pageControl.take"
            [totalRecords]="pageControl.itemCount"
            [showCurrentPageReport]="true"
            [rowsPerPageOptions]="[10, 25, 50]"
            currentPageReportTemplate="{first} - {last} de {totalRecords}"
            appendTo="body"
          />
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
